export default "__VITE_ASSET__bj2SNTs2__"